const initialState = {
	pastMeetings: [],
	presentMeetings: [],
	futureMeetings: []
};

const meetings = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_PAST_MEETING': {
			const { meetings } = action.payload;

			return { ...state, pastMeetings: meetings };
		}

		case 'SET_PRESENT_MEETING': {
			const { meetings } = action.payload;

			return { ...state, presentMeetings: meetings };
		}

		case 'SET_FUTURE_MEETING': {
			const { meetings } = action.payload;

			return { ...state, futureMeetings: meetings };
		}

		default:
			return state;
	}
};

export default meetings;
